module.exports = __webpack_public_path__ + "media/images/banner/planning/ja-7066c7e46967e54d740e9247a48ded39.jpg";